export default __webpack_public_path__ + "static/media/ico_link_avatar.6dc2ed25.svg";